// extracted by mini-css-extract-plugin
export default {"container":"Preview_container__A+kpu","iframe":"Preview_iframe__pM5Gv","sizeToolbar":"Preview_sizeToolbar__k3icH","mobileSize":"Preview_mobileSize__KLtu6"};